import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from './utils'

/* http */
import request from './utils/request'

/* cookie */
import cookie from 'js-cookie'

/* swiper */
import 'swiper/dist/css/swiper.css'

/* element-ui */
import './plugins/element.js'

/* global css */
import '@/styles/index.scss'

if (utils.isIE()) {
  Vue.prototype.$notify.warning({
    title: '提示',
    message: '此网站不兼容IE内核浏览器，请使用其他第三方浏览器或切换极速模式进行浏览操作',
    duration: 0
  })
}

/* 挂载全局函数 */
Vue.prototype.$cookie = cookie

const _success = Vue.prototype.$message.success
Vue.prototype.$message.success = function(message = '成功') {
  _success(message)
}

const _error = Vue.prototype.$message.error
Vue.prototype.$message.error = function(message = '发生未知错误，请稍后重试') {
  _error(message)
}

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
